module.exports = __webpack_public_path__ + "img/physical-exercise.9e61be68.png";